export enum ServiceLevelType {
    EXPLORE = 'EXPLORE',
}
